import axios from 'axios';
import getIpfsImageUrl from './getIpfsImageUrl';
import getMetadata from './getMetadata';
import parseCID from './parseCID';

const BLACK_LIST = [
  403996358, 654669653, 685113393, 685120777, 685125550, 685126834, 685128483, 685129794, 685131187, 685132319, 731917168, 805452498, 805453349,
  814497431,
];

export const getCreatedAssetsNoMetadata = async (address) => {
  const apiUrl = `https://mainnet-idx.algonode.cloud/v2/accounts/${address}/created-assets`;
  const { data } = await axios.get(apiUrl);
  const assets = data.assets;
  let next = data['next-token'];

  while (next) {
    const { data } = await axios.get(apiUrl, {
      params: {
        next,
      },
    });
    assets.push(...data.assets);
    next = data['next-token'];
  }

  return assets;
};


export async function getCreatedAssets(address, nftType = 'arc19') {
  const apiUrl = `https://mainnet-idx.algonode.cloud/v2/accounts/${address}/created-assets`;
  const { data } = await axios.get(apiUrl);
  const assets = data.assets;
  let next = data['next-token'];

  while (next) {
    const { data } = await axios.get(apiUrl, {
      params: {
        next,
      },
    });
    assets.push(...data.assets);
    next = data['next-token'];
  }

  const chunks = [];
  const chunkSize = 50;
  for (let i = 0; i < assets.length; i += chunkSize) {
    chunks.push(assets.slice(i, i + chunkSize));
  }

  let theAssets = [];
  for (const chunk of chunks) {
    const chunkAssets = await Promise.all(chunk.map((asset) => getAssetExtraInfo(asset, nftType)));
    theAssets.push(...chunkAssets);
  }

  return theAssets;
}

export async function getAssetExtraInfo(asset, nftType) {
  const url = asset.params.url;

  if (nftType === 'arc19') {
    const reserve = asset.params.reserve;
    const cid = parseCID(url, reserve);
    const imageId = cid.toString();
    asset.cid = imageId;
    asset.image = getIpfsImageUrl(imageId);
  } else if (nftType === 'arc69') {
    const imageId = url.split('ipfs://')[1];
    asset.image = getIpfsImageUrl(imageId);
  }

  try {
    asset.metadata = await getMetadata(asset.index);
  } catch (error) {}

  return asset;
}
